<template>
  <div class="">
    <!-- 查询表单 -->
    <div>
      <el-form ref="queryParamForm" :model="queryParamForm" label-width="100px">
        <el-row :gutter="20">
          <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
            <el-form-item label="物品编号">
              <el-input clearable v-model="queryParamForm.itemCode"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
            <el-form-item label="IMEI号">
              <el-input clearable v-model="queryParamForm.imei"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
            <el-form-item label="分类">
              <el-select
                clearable
                v-model="queryParamForm.categoryId"
                placeholder="请选择"
                @change="changeOtherOptions()"
              >
                <el-option
                  v-for="item in queryCategoryOptions"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
            <el-form-item label="品牌">
              <el-select
                clearable
                v-model="queryParamForm.brandId"
                placeholder="请选择"
                @change="getModelList()"
              >
                <el-option
                  v-for="item in queryBrandOptions"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
            <el-form-item label="机型">
              <el-select
                clearable
                v-model="queryParamForm.modelId"
                placeholder="请选择"
                filterable
              >
                <el-option
                  v-for="item in queryModelList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
            <el-form-item label="质检人">
              <el-input clearable v-model="queryParamForm.createBy"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="6">
            <el-form-item label="质检时间">
              <el-date-picker
                clearable
                v-model="queryParamForm.createTime"
                type="daterange"
                align="right"
                unlink-panels
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-button type="primary" @click="getServiceProviderListSearch"
              >查询</el-button
            >
            <el-upload
              style="display: inline"
              action="aa"
              :show-file-list="false"
              :before-upload="importSendInfo"
            >
              <el-button
                style="margin-left: 10px"
                type="primary"
                v-loading="fullscreenLoading"
                >批量导入质检信息</el-button
              >
            </el-upload>
            <a type="primary" style="margin-left:10px" @click="getQualityTemplete">质检导入模板下载</a>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div style="margin-top: 20px">
      <!-- 表格 -->
      <el-table :data="tableData" border style="width: 100%">
        <el-table-column prop="itemCode" label="物品编号"> </el-table-column>
        <el-table-column prop="categoryName" label="分类"> </el-table-column>
        <el-table-column prop="brandName" label="品牌"> </el-table-column>
        <el-table-column prop="modelName" label="机型"> </el-table-column>
        <el-table-column prop="imei" label="IMEI号"> </el-table-column>
        <el-table-column prop="gradeName" label="等级"> </el-table-column>
        <el-table-column prop="qualityAmount" label="质检价"> </el-table-column>
        <el-table-column prop="createTime" label="质检时间"> </el-table-column>
        <el-table-column prop="qualityerName" label="质检人"> </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button @click="editormodel(scope.row)" type="text" size="small"
              >查看质检报告</el-button
            >
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <el-pagination
        style="margin-top: 20px"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 40, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="tableTotal"
      >
      </el-pagination>
    </div>

    <!-- 修改或新建对话框 -->
    <el-dialog title="查看质检报告" :visible.sync="isDlg" width="700px">
      <div style="margin: 20px">
        <div>
          <el-form
            ref="editServiceProviderForm"
            :model="editServiceProviderForm"
            :rules="editorFormRules"
            label-width="120px"
          >
            <el-row>
              <el-col :span="12"
                >品牌：{{ editServiceProviderForm.brandName }}</el-col
              >
              <el-col :span="12"
                >型号：{{ editServiceProviderForm.modelName }}</el-col
              >
            </el-row>
            <el-row style="margin-top: 10px">
              <el-col :span="12"
                >内存：{{ editServiceProviderForm.memory }}</el-col
              >
              <el-col :span="12"
                >IMEI：{{ editServiceProviderForm.imei }}</el-col
              >
            </el-row>
            <el-row style="margin-top: 10px">
              <el-col :span="12"
                >机器概况：{{ editServiceProviderForm.machineOverview }}</el-col
              >
              <el-col :span="12"
                >购买渠道：{{ editServiceProviderForm.purchaseChannel }}</el-col
              >
            </el-row>
            <el-row style="margin-top: 10px">
              <el-col :span="12"
                >网络制式：{{ editServiceProviderForm.networkSystem }}</el-col
              >
              <el-col :span="12"
                >屏幕外观：{{
                  editServiceProviderForm.screenAppearance
                }}</el-col
              >
            </el-row>
            <el-row style="margin-top: 10px">
              <el-col :span="12"
                >外观项：{{ editServiceProviderForm.appearanceItem }}</el-col
              >
              <el-col :span="12"
                >显示项：{{ editServiceProviderForm.displayItem }}</el-col
              >
            </el-row>
            <el-row style="margin-top: 10px">
              <el-col :span="12"
                >屏幕维修项：{{
                  editServiceProviderForm.screenMaintenanceItem
                }}</el-col
              >
              <el-col :span="12"
                >相机维修项：{{
                  editServiceProviderForm.cameraMaintenanceItem
                }}</el-col
              >
            </el-row>
            <el-row style="margin-top: 10px">
              <el-col :span="12"
                >后壳维修项：{{
                  editServiceProviderForm.backCoverMaintenanceItem
                }}</el-col
              >
              <el-col :span="12"
                >功能项：{{ editServiceProviderForm.functionItem }}</el-col
              >
            </el-row>
            <el-row style="margin-top: 10px">
              <el-col :span="12"
                >维修项：{{ editServiceProviderForm.maintenanceItem }}</el-col
              >
              <el-col :span="12"
                >ID：{{ editServiceProviderForm.machineId }}</el-col
              >
            </el-row>
            <el-row style="margin-top: 10px">
              <el-col :span="12"
                >等级：{{ editServiceProviderForm.gradeName }}</el-col
              >
              <el-col :span="12"
                >颜色：{{ editServiceProviderForm.color }}</el-col
              >
            </el-row>
            <el-row style="margin-top: 10px">
              <el-col :span="12"
                >质检价：{{ editServiceProviderForm.qualityAmount }}</el-col
              >
              <el-col :span="12"
                >备注问题：{{ editServiceProviderForm.remark }}</el-col
              >
            </el-row>
          </el-form>
        </div>
        <div style="text-align: right">
          <el-button style="margin: 10px 20px" @click="closeEditormodelDlg"
            >关闭</el-button
          >
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  components: {},
  props: {},
  data() {
    return {
      fullscreenLoading: false,
      // 查询数据
      queryParamForm: {
        itemCode: null,
        imei: null,
        categoryId: null,
        brandId: null,
        modelId: null,
        createBy: null,
        createTime: null,
      },
      systemQuoteOptions: [
        { id: 0, name: "否" },
        { id: 1, name: "是" },
      ],
      defaultsOptions: [
        { id: 0, name: "否" },
        { id: 1, name: "是" },
      ],

      // 表格数据
      tableTotal: 0,
      tableData: [],
      pageSize: 10,
      currentPage: 1,

      // 新建编辑对话框数据
      userInfo: {},

      queryModelList: [],

      queryBrandOptions: [],

      queryCategoryOptions: [],

      isDlg: false,
      editServiceProviderForm: {
        id: null,
        code: null,
        name: null,
        contactPerson: null,
        contactNumber: null,
        systemQuotes: 0,
        defaults: 0,
      },

      editorFormRules: {},

      dlgType: "change",

      // 选择
      loading: false,
    };
  },
  watch: {},
  computed: {},
  methods: {
    // 批量导入
    importSendInfo(file) {
      this.fullscreenLoading = true;
      let formData = new FormData();
      formData.append("file", file);
      this.$api.importQualityTemplete(formData).then((res) => {
        this.fullscreenLoading = false;
        if (res.code === 200) {
          this.$message({
            message: "导入成功",
            type: "success",
          });
          this.getServiceProviderListSearch();
        }
      });
      return false;
    },
    getQualityTemplete() {
      window.open((process.env.NODE_ENV === "development" ? "/api2": "")+`/consignment/qualityInfo/getQualityTemplete`, "_blank");
    },
    getCategroyOptions() {
      let self = this;
      this.$api
        .getTemplateValue({
          typeKey: "category",
        })
        .then((res) => {
          self.queryCategoryOptions = res.data || [];
        });
    },
    //改变分类，品牌和等级集合发生变化
    changeOtherOptions() {
      let self = this;
      self.$set(self.queryParamForm, "brandId", null);
      self.$set(self.queryParamForm, "modelId", null);
      self.$set(self, "queryModelList", []);
      self.getBrandOptions();
    },
    getBrandOptions() {
      let categoryId = this.queryParamForm.categoryId;
      if (categoryId === "") {
        this.$set(this, "queryBrandOptions", []);
      } else {
        let self = this;
        self.$api
          .getClass({
            categoryId: categoryId,
            typeKey: "phoneBrand",
            status: 1,
            page: 1,
            size: 100000,
          })
          .then((res) => {
            self.queryBrandOptions = res.data.records || [];
          });
      }
    },
    getModelList() {
      let brandId = this.queryParamForm.brandId;
      this.$set(this.queryParamForm, "modelId", null);
      if (brandId === "") {
        this.$set(this, "queryModelList", []);
      } else {
        let self = this;
        self.$api
          .getClass({
            brandId: brandId,
            typeKey: "phoneModal",
            status: 1,
            page: 1,
            size: 100000,
          })
          .then((res) => {
            self.queryModelList = res.data.records || [];
          });
      }
    },
    deleteServiceProvider(id) {
      let self = this;
      self.$confirm("是否删除").then(() => {
        self.$api.deleteServiceProvider({ id: id }).then((res) => {
          if (res.code === 200) {
            this.$message({
              message: "删除成功",
              type: "success",
            });
            this.getServiceProviderListSearch();
          }
        });
      });
    },
    // 分页函数
    handleSizeChange(val) {
      console.log(val);
      this.pageSize = val;
      // 每次调整pagesize后，跳回第一页，保证有数据及请求不会报错
      this.handleCurrentChange(1);
    },
    handleCurrentChange(val) {
      this.currentPage = val;

      // 重新请求表格数据
      this.getServiceProviderListSearch();
    },

    // 获取表格数据
    getServiceProviderListSearch() {
      let self = this;
      self.$api
        .getConsignmentQualityList({
          page: self.currentPage,
          size: self.pageSize,
          qualityTimeStart:
            self.queryParamForm.createTime instanceof Array &&
            self.queryParamForm.createTime.length > 1
              ? self.queryParamForm.createTime[0] + " 00:00:00"
              : null,
          qualityTimeEnd:
            self.queryParamForm.createTime instanceof Array &&
            self.queryParamForm.createTime.length > 1
              ? self.queryParamForm.createTime[1] + " 23:59:59"
              : null,
          itemCode: self.queryParamForm.itemCode || null,
          createBy: self.queryParamForm.createBy || null,
          imei: self.queryParamForm.imei || null,
          categoryId: self.queryParamForm.categoryId || null,
          brandId: self.queryParamForm.brandId || null,
          modelId: self.queryParamForm.modelId || null,
        })
        .then((res) => {
          self.tableData = res.data.records || [];
          self.tableTotal = res.data.total;
        });
    },

    // 添加
    addBasePrice() {
      this.dlgType = "new";
      this.editServiceProviderForm =
        this.$options.data().editServiceProviderForm;
      this.$nextTick(() => {
        this.$refs["editServiceProviderForm"].clearValidate();
      });
      this.isDlg = true;
    },

    // 修改
    editormodel(row) {
      let self = this;
      self.dlgType = "change";
      self.editServiceProviderForm = JSON.parse(JSON.stringify(row));
      this.isDlg = false;
      this.$nextTick((e) => {
        self.isDlg = true;
      });
    },

    // 关闭编辑对话框
    closeEditormodelDlg() {
      this.isDlg = false;
    },

    // 提交编辑（新建或者修改）
    submitEditor() {
      let self = this;
      this.$refs["editServiceProviderForm"].validate((valid) => {
        if (valid) {
          let params = this.editServiceProviderForm;
          self.$api.updateServiceProvider(params).then((res) => {
            if (res.code === 200) {
              this.$message({
                message: "操作成功",
                type: "success",
              });
              self.getServiceProviderListSearch();
              self.closeEditormodelDlg();
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    changeStatus(row, newStatus) {
      let self = this;
      row.status = newStatus;
      row.modelId = null;
      this.$api.updateServiceProvider(row).then((res) => {
        if (res.code === 200) {
          this.$message({
            message: "修改成功",
            type: "success",
          });
          self.getServiceProviderListSearch();
        }
      });
    },
  },
  created() {},
  mounted() {
    let self = this;
    self.getServiceProviderListSearch();
    self.getCategroyOptions();
  },
};
</script>
<style lang="less" scoped>
</style>
